import { observer } from "mobx-react";
import * as React from "react";
import { getJobCategoryOptions } from "../../../constants";
import { applicationStore } from "../../../stores/ApplicationStore";
import { pushRoute } from "../../app/router/history";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { optionToString } from "../../util/helpers";
import { ApplicationRoutes } from "../router/ApplicationRoutes";
import { Success } from "../Success";

export const SuccessSite = observer(() => {
    React.useEffect(() => {
        if (!applicationStore.isStepFinished["verification"]) {
            pushRoute(ApplicationRoutes.PERSONAL_DATA);
        }
    }, []);

    return (
        <ContentWrapper>
            <Success
                header={optionToString(getJobCategoryOptions(), applicationStore.currentApplication.jobCategory)}
            />
        </ContentWrapper>
    );
});
